import axios from "axios";
import { GraphData } from "views/planning-prognosis/features/view-fish-group/types/default-fish-group-graph.type";
import { CreateQuickSimInput } from "../types/create-quick-sim-input.type";

export const postQuickSim = async (
    globalCompanyId: string,
    request: CreateQuickSimInput
  ): Promise<GraphData[]> => {
    const res = await axios.post<GraphData[]>(`/ewosapi/v1/planandprognosis/calculatequicksimulation/${globalCompanyId}`, request);
    return res.data;
  };